import { makeStyles } from "tss-react/mui";

export const useProcessEmailTokenStyles = makeStyles()(() => ({
    root: {
        flex: "1 1 auto",
    },
}));
